export default {
  timetable: "Stundenplan",
  yourCourses: "Ihre Kurse",
  "There are no events on this day.": "An diesem Tag gibt es keine Ereignisse",
  Today: "Heute",
  Month: "Monat",
  Week: "Woche",
  Day: "Tag",
  Year: "Jahr",
  More: "Mehr",
  "Application for authorization of exceptional absence": "Antrag auf außerordentliche Abwesenheitsgenehmigung",
  "Add a new event": "Neues Ereignis hinzufügen",
};
